import MousePosition from 'leaflet-mouse-position'

import 'leaflet-mouse-position/src/L.Control.MousePosition.css'

export default MousePosition
